/* External dependencies */
import { Epic, ofType } from 'redux-observable';
import { from, of } from 'rxjs';
import { switchMap, mergeMap, catchError } from 'rxjs/operators';
import { Action } from 'redux';

/* Local dependencies */
import { deleteDeviceRequest } from './service';
import {
  DeleteDeviceActionTypes,
  deleteDeviceSuccess,
  deleteDeviceFailure,
  DeleteDeviceAction,
} from './acrions';
import { DeleteDeviceInput } from '../../types';
import { listDevice } from '../../list-device/redux/actions';
import { RootState } from '../../../../redux/store';

export const deleteDeviceEpic: Epic<Action, Action, RootState> = (action$) =>
  action$.pipe(
    ofType(DeleteDeviceActionTypes.DELETE_DEVICE_REQUEST),
    switchMap((action: DeleteDeviceAction) =>
      from(deleteDeviceRequest(action.payload as DeleteDeviceInput)).pipe(
        mergeMap((message: string) => [deleteDeviceSuccess(message), listDevice()]),
        catchError((error) =>
          of(
            deleteDeviceFailure(
              error instanceof Error ? error.message : 'Failed to delete device',
            ),
          ),
        ),
      ),
    ),
  ); 